import { FormBase } from "core/components";

export default class TrackingCaseDocumentFieldValueEditDynamicForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: []
        };
    }
}